// src/utils/request.js
import axios from 'axios'
import ElementUI from 'element-ui'


// const VUE_APP_BASE_API = 'http://192.168.100.47:55708';
const VUE_APP_BASE_API = 'https://api.zaoying.cn';
// const VUE_APP_BASE_API = 'http://test.zaoying.cn';

// 创建自定义实例
const service = axios.create({
    baseURL: VUE_APP_BASE_API, // 从环境变量读取基础地址
    timeout: 15000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        return config
    },  
    error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)


// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 自定义状态码验证（根据后端约定）
        if (res.code == 50001) {
            ElementUI.$message({
                message: '未找到对应的新闻信息',
                type: 'warning'
            })
        } else if (res.code == 200) {
            return res.data
        }
    },
    error => {
        // 处理HTTP网络错误
        if (error && error.data.code) {
            if (error.data.code == 50001) {
                ElementUI.$message({
                    message: '未找到对应的新闻信息',
                    type: 'warning'
                })
            }
            else if (error.data.code == 50001) {
                ElementUI.$message({
                    message: '未找到对应的新闻信息',
                    type: 'warning'
                })
            }
        }
        return Promise.reject(error)
    }
)
export default service
